import React from 'react';
import { useUpdateEffect } from 'react-use';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { useRoutes } from '../../../config/VideoAppContext';
import { findRoute } from '../../../models/PlayRoute';
import { useSearchState } from '../../../pages/Search/SearchContext';
import { useHeaderState } from '../HeaderContext';
import { MainNaviContainer } from './MainNavigation.styles';
import { MainNavigationContent } from './MainNavigationContent';
import { jsx as _jsx } from "react/jsx-runtime";
export const MainNavigation = () => {
  const routes = useRoutes();
  const {
    hasSecondLevelNavi,
    showMainNavi,
    showMainNaviOnSmallScreens,
    hasScrolled,
    layout
  } = useHeaderState();
  const analytics = useAnalyticsDispatch();
  const {
    searchOpen,
    searchPageOpen,
    query,
    showAll,
    previousPage
  } = useSearchState();
  const quickSearchVisible = searchOpen && !searchPageOpen || query.searchTerm.trim() === '' && searchPageOpen && !showAll;
  useUpdateEffect(() => {
    if (!quickSearchVisible && (query.searchTerm.trim() !== '' || showAll)) {
      const referrerPage = previousPage ? findRoute(previousPage, routes)?.pageId : undefined;
      analytics({
        type: 'perform-search',
        referrerPage,
        searchTerm: query.searchTerm
      });
    }
  }, [quickSearchVisible]);
  return /*#__PURE__*/_jsx(MainNaviContainer, {
    showTransparent: layout === 'transparent' && !searchOpen,
    hasScrolled: hasScrolled,
    showMainNavi: showMainNavi,
    showMainNaviOnSmallScreens: showMainNaviOnSmallScreens,
    hasSecondLevelNavi: hasSecondLevelNavi,
    children: /*#__PURE__*/_jsx(MainNavigationContent, {})
  });
};